import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { Note, NOTE_TYPE } from "../../../../../components/note/note";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";


const RestockNoteRefundProcess: React.FC = () => {

    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-rma-card-popups';

    return (
        <>
            <FontBody1>{getTranslation('RESTOCK_NOTE_1', pageScope)}</FontBody1>
            <Note type={NOTE_TYPE.INFORMATION} body={<>
                <FontBody2>{getTranslation('RESTOCK_NOTE_2', pageScope)}</FontBody2>
            </>} />
            <FontBody1>{getTranslation('RESTOCK_VALIDATION', pageScope)}</FontBody1>
        </>
    );
}

export default RestockNoteRefundProcess;
